import { create } from 'zustand';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india`;

export const useIndiaCompanyStore = create((set, get) => ({
  companyData: null,
  loading: false,
  error: null,
  activeTab: 'overview',

  fetchCompany: async (symbol) => {
    if (get().companyData?.symbol === symbol.toUpperCase() && !get().error) return;
    set({ loading: true, error: null, companyData: null });
    try {
      const { data } = await axios.get(`${API}/company/${encodeURIComponent(symbol)}`);
      set({ companyData: data, loading: false });
    } catch (err) {
      const msg = err?.response?.data?.detail || err.message || 'Failed to load company';
      set({ error: msg, loading: false });
    }
  },

  setTab: (tab) => set({ activeTab: tab }),

  reset: () => set({ companyData: null, loading: false, error: null, activeTab: 'overview' }),
}));
